<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    color="#1A1C24"
    dark
    floating
    mobile-breakpoint="991"
    persistent
    width="260"
  >
    <!-- <template v-slot:img="attrs">
      <v-img
        v-bind="attrs"
        gradient="to top, rgba(0, 0, 0, .7), rgba(0, 0, 0, .7)"
      />
    </template> -->
    <v-list-item two-line class="my-3">
      <v-list-item-title class="title">
        <router-link to="/">
          <v-img src="@/assets/img/Logotype_Dark.png" height="40px" contain />
        </router-link>
      </v-list-item-title>
    </v-list-item>

    <v-divider class="mx-3 ma-5" />

    <v-list class="pb-0">
      <v-list-item to="/projects" active-class="accent white--text">
        <v-list-item-action>
          <v-icon>mdi-folder-multiple-outline</v-icon>
        </v-list-item-action>

        <v-list-item-title>Projects</v-list-item-title>
      </v-list-item>
    </v-list>

    <v-list v-if="false" dense nav class="accent lighten-1 pl-5">
      <v-subheader>Project</v-subheader>
      <v-list-item
        v-for="(action, action_name) in actions"
        :key="action_name"
        to=""
        active-class="accent white--text"
      >
        <v-list-item-action>
          <v-icon small class="ml-3">
            {{ action.icon }}
          </v-icon>
        </v-list-item-action>

        <v-list-item-title v-text="action.text" />
      </v-list-item>
    </v-list>

    <v-list>
      <v-list-item to="/library" active-class="accent white--text">
        <v-list-item-action>
          <v-icon>mdi-package-variant-closed</v-icon>
        </v-list-item-action>

        <v-list-item-title>Library</v-list-item-title>
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <v-list nav>
        <v-list-item @click="handleLogout">
          <v-list-item-action>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-action>

          <v-list-item-title class="font-weight-light">
            Sign Out
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { logout } from "@/utils/auth";

import { mapMutations, mapState } from "vuex";

export default {
  props: {
    opened: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    menu: null,
    /* item: 0, */
    /* links: [
            { text: 'Projects', icon: 'mdi-folder-multiple-outline', to: '/projects' },
            { text: 'Library', icon: 'mdi-package-variant-closed', to: '/library' },
      ], */
    actions: {
      dashboard: {
        text: "Dashboards",
        description: "Dashboard is really cool",
        icon: "mdi-view-dashboard-outline",
        CreateInDialog: true
      },
      query: {
        text: "Queries",
        description: "",
        icon: "mdi-play-box-outline"
      },
      dataset: {
        text: "Datasets",
        description: "",
        icon: "mdi-table"
      },
      function: {
        text: "Functions",
        description: "",
        icon: "mdi-code-tags"
      },
      integration: {
        text: "Integrations",
        description: "",
        icon: "mdi-access-point"
      },
      trigger: {
        text: "Triggers",
        description: "",
        icon: "mdi-update"
      },
      api: {
        text: "Apis",
        description: "",
        icon: "mdi-access-point"
      }
    }
  }),
  watch: {
    $route(val) {
      this.menu = val.meta.menu;
    }
  },
  computed: {
    ...mapState("app", ["image", "color"]),
    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      }
    }
  },

  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    handleLogout() {
      logout();
    }
  }
};
</script>
